export default __webpack_public_path__ + "media/images/images/portfolio/width-600/portfolio-12-8172b8f490bb3d43aad0795a63dc6a0b.jpg";